export default {
    columns: [
        { key: 'cwe_url', label: 'URL', sortable: false, alignHead: 'center', align: 'center', verticalAlign: 'middle', },
        { key: 'cwe_obs', label: 'Obs', sortable: false, alignHead: 'center', align: 'center', verticalAlign: 'middle', },
        { key: 'cwe_actions', label: 'Ações', sortable: false, alignHead: 'center', align: 'center', verticalAlign: 'middle', },
    ]
}